import { Instagram } from "lucide-react";
import { FadeUp, MaskLine } from "./Reveal";
import { SITE, IMAGES } from "../config/site";

const POSTS = [
  { src: IMAGES.storyBrewed, alt: "Freshly brewed filter coffee poured between brass vessels" },
  { src: IMAGES.instaCup, alt: "A warm cup of coffee on a quiet morning" },
  { src: IMAGES.storyFilter, caption: "The ritual", alt: "Traditional South Indian coffee filter ritual" },
  { src: IMAGES.instaFriends, alt: "Friends sharing coffee at a wooden table" },
  { src: IMAGES.instaPair, alt: "Two friends catching up over coffee" },
  { src: IMAGES.instaSteps, alt: "Laughing together on the steps with coffee" },
];

const InstagramSection = () => (
  <section id="instagram" data-testid="instagram-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="mb-14 text-center">
        <FadeUp>
          <p className="mb-5 text-[11px] uppercase tracking-widest2 text-gold">@tmvfoods</p>
        </FadeUp>
        <h2 className="font-display text-4xl leading-tight text-cream sm:text-5xl">
          <MaskLine delay={0.05}>Coffee moments</MaskLine>
          <MaskLine delay={0.18} className="italic text-gold">
            worth sharing.
          </MaskLine>
        </h2>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3">
        {POSTS.map((post, i) => (
          <FadeUp key={i} delay={i * 0.06}>
            <a
              data-testid={`instagram-post-${i + 1}`}
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-square overflow-hidden rounded-sm bg-bark focus:outline-none focus:ring-1 focus:ring-gold"
            >
              <img
                src={post.src}
                alt={post.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.08]"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-espresso/60 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <span className="flex h-12 w-12 items-center justify-center rounded-full border border-cream/40 text-cream">
                  <Instagram size={18} />
                </span>
              </div>
            </a>
          </FadeUp>
        ))}
      </div>

      <FadeUp delay={0.2} className="mt-12 text-center">
        <a
          data-testid="instagram-follow-button"
          href={SITE.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 rounded-full border border-cream/25 px-8 py-4 text-xs font-medium uppercase tracking-[0.18em] text-cream transition-all duration-300 hover:border-gold hover:text-gold"
        >
          <Instagram size={15} />
          Follow TMV Coffee
        </a>
      </FadeUp>
    </div>
  </section>
);

export default InstagramSection;
